import { computed } from 'vue';
import router from '@/router/index.js';
import storeState from '@/store/index';
// const $emit = defineEmits()
export default {
  name: 'popup-news',
  props: {
    popupData: {}
  },
  setup(props, context) {
    let account_list = computed(() => storeState.getters.account_list);
    const goDetailsPage = data => {
      router.push({
        path: '/bookDetail',
        query: {
          bid: data.bookId,
          type: account_list.value[0].videoType
        }
      });
    };
    const closePopup = () => {
      context.emit('closeEvent');
    };
    return {
      goDetailsPage,
      closePopup
    };
  }
};